import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'

import EditorIndexQuestion from '../EditorIndexQuestion/EditorIndexQuestion'
import EditorIndexProject from '../EditorIndexProject/EditorIndexProject'
import EditorIndexRanking from '../EditorIndexRanking/EditorIndexRanking'
import IndexAddCell from '../../molecules/IndexAddCell/IndexAddCell'
import { QuizType } from '../../../../commons/EditorStatus'
import './EditorFooter.css'

const EditorFooter = ({
  projectTitle,
  projectId,
  projectImageUrl,
  questions,
  handleSelect,
  handleAddQuestion,
  handleDeleteQuestion,
  selectedIndex,
  selectedType,
  handleChangeQuestionIndex
}) => {
  // 問題ページ
  const sortableItemList = questions.map((question, i) => {
    let className = 'item'
    const isSelected = QuizType.QUESTION.value === selectedType && i === selectedIndex
    if (isSelected) {
      className += ' selected'
    }

    const SortableItem = SortableElement(({ question, quizIndex }) => (
      <div styleName="itemContainer">
        <div
          styleName={className}
          onClick={() => handleSelect(quizIndex, QuizType.QUESTION.value)}
          key={`editor-footer-${question.id}`}
        >
          <EditorIndexQuestion index={quizIndex + 1} question={question} isSelected={isSelected} />
        </div>
        {questions.length > 1 ? (
          <div
            styleName="close"
            onClick={() => handleDeleteQuestion({ projectId: projectId, questionId: question.id })}
          />
        ) : null}
      </div>
    ))
    return <SortableItem question={question} index={i} quizIndex={i} key={`editor-footer-question-${i}`} />
  })

  const SortableList = SortableContainer(() => <div styleName="sotable-list">{sortableItemList}</div>)

  const CONTENT_WIDTH = 1000
  const basePositionX = (window.innerWidth - CONTENT_WIDTH) / 2
  const MARGIN = 15
  const CELL_WIDTH = 150 // 幅とマージン含め
  let positionX = basePositionX - MARGIN
  if (selectedType === QuizType.QUESTION.value) {
    positionX -= CELL_WIDTH * (selectedIndex + 1) // 表紙分を足す
  } else if (selectedType === QuizType.RANKING.value) {
    positionX -= CELL_WIDTH * (questions.length + 2) // 表紙と問題追加分を足す
  }

  return (
    <div styleName="container" style={{ transform: `translateX(${positionX}px)` }}>
      <div styleName="row">
        <div
          styleName={`item${selectedType === QuizType.FIRSTPAGE.value ? ' selected' : ''}`}
          onClick={() => handleSelect(0, QuizType.FIRSTPAGE.value)}
        >
          <EditorIndexProject
            title={projectTitle}
            isSelected={selectedType === QuizType.FIRSTPAGE.value}
            image={projectImageUrl}
          />
        </div>

        <SortableList axis="x" onSortEnd={data => handleChangeQuestionIndex(data)} pressDelay={150} />

        <div styleName="item" onClick={() => handleAddQuestion()}>
          <IndexAddCell />
        </div>

        <div
          styleName={`item${selectedType === QuizType.RANKING.value ? ' selected' : ''}`}
          onClick={() => handleSelect(0, QuizType.RANKING.value)}
        >
          <EditorIndexRanking />
        </div>
      </div>
    </div>
  )
}

EditorFooter.propTypes = {
  projectTitle: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  projectImageUrl: PropTypes.string.isRequired,
  questions: PropTypes.array,
  handleSelect: PropTypes.func.isRequired,
  handleAddQuestion: PropTypes.func.isRequired,
  handleDeleteQuestion: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number,
  selectedType: PropTypes.number,
  handleChangeQuestionIndex: PropTypes.func.isRequired
}

export default compose(pure)(EditorFooter)
